<atl-ngb-modal-header title="Shared.Title.Message_preview" [isClient]="true" (closeModalEvent)="closeModal()"></atl-ngb-modal-header>

<div class="message-editor-view__body v-scrollbar">
  <atl-shadow-dom-content class="product-description empty-font-size without-first-margin">
    <div [innerHTML]="value | safeHtml"></div>
  </atl-shadow-dom-content>
</div>
